import { SwabSample } from "../../swab-sample/models/swabSample";

/**
 * @description pairs a swab to a plate position
 */
export class SwabByPosition {
    position: string;
    swab: SwabSample;
}